import { render, staticRenderFns } from "./SettingsChangedMessage.vue?vue&type=template&id=81cd4d8a&scoped=true&"
import script from "./SettingsChangedMessage.vue?vue&type=script&lang=ts&"
export * from "./SettingsChangedMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsChangedMessage.vue?vue&type=style&index=0&id=81cd4d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd4d8a",
  null
  
)

export default component.exports